import { render, staticRenderFns } from "./smsConfig.vue?vue&type=template&id=4150fb26&scoped=true&"
import script from "./smsConfig.vue?vue&type=script&lang=js&"
export * from "./smsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150fb26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4150fb26')) {
      api.createRecord('4150fb26', component.options)
    } else {
      api.reload('4150fb26', component.options)
    }
    module.hot.accept("./smsConfig.vue?vue&type=template&id=4150fb26&scoped=true&", function () {
      api.rerender('4150fb26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/webConfig/smsConfig.vue"
export default component.exports